import { useState } from "react";
import toast from "react-hot-toast";
import { initiatePayment } from "../services/payment.service";

export const usePayment = (orderResponse) => {
    const [selectedPayment, setSelectedPayment] = useState(null);
    const [isProcessing, setIsProcessing] = useState(false);

    const startPayment = async () => {
        try {
            if (!selectedPayment) {
                toast.error("Please select a payment method!");
                return;
            }
         

            const gateway = orderResponse?.data?.payment_gateways.find(
                (g) => g.provider === selectedPayment
            );

            if (!gateway) {
                toast.error("Invalid payment method selected!");
                return;
            }

            setIsProcessing(true);

            const payload = {
                ref_id: orderResponse?.data?.ref_id,
                provider: gateway.provider,
                secret: gateway.secret,
                redirect_url: `${window.location.origin}/payment/callback`,
            };

            const orderData = await initiatePayment(payload);

            if (!orderData?.success) {
                setIsProcessing(false);
                toast.error(orderData?.message || "Payment failed");
                return;
            }

            window.location.href = orderData?.data?.payment_link;
        } catch (err) {
            setIsProcessing(false);
            toast.error("Something went wrong");
        }
    };

    return {
        selectedPayment,
        setSelectedPayment,
        isProcessing,
        startPayment,
    };
};
